// import React, { useState, useEffect, useRef } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { Download, Trash2, RefreshCw, File, Calendar, HardDrive, Upload, Key } from 'lucide-react';
// import { listAllData, decodeFile, deleteData, decodeFileByKey } from '../services/api';

import React, { useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Download, RefreshCw, Upload, Key, File } from 'lucide-react';
import { toast } from 'react-toastify';
import { decodeFileByKey } from '../services/api';

// interface DataItem {
//   dataName: string;
//   dnaSequenceCount: number;
//   createdAt: string;
//   processHeader: {
//     version: string;
//     dnaLen: number;
//     dnaSha256: string;
//     families: string[];
//     coilAllOffsets: boolean;
//     bitLen: number;
//     fragmentCount: number;
//     uniquePatterns: number;
//     unique4Mers: number;
//     origName?: string;
//     origExt?: string;
//     mime?: string;
//   };
// }

const DownloadPage: React.FC = () => {
  // const [dataItems, setDataItems] = useState<DataItem[]>([]);
  // const [loading, setLoading] = useState(true);
  // const [downloading, setDownloading] = useState<string | null>(null);
  // const [deleting, setDeleting] = useState<string | null>(null);
  // const [selectedKeyFiles, setSelectedKeyFiles] = useState<{ [dataName: string]: File | null }>({});
  // const [showKeyFileUpload, setShowKeyFileUpload] = useState<string | null>(null);
  const [globalKeyFile, setGlobalKeyFile] = useState<File | null>(null);
  const [globalDecoding, setGlobalDecoding] = useState(false);
  
  // const keyFileInputRef = useRef<HTMLInputElement>(null);
  const globalKeyInputRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const isDemoMode =
    location.pathname === '/demo/download' || location.pathname.startsWith('/demo/');
  const uploadLink = isDemoMode ? '/demo/upload' : '/upload';

  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const data = await listAllData();
  //     setDataItems(data);
  //   } catch (error: any) {
  //     toast.error('Failed to fetch data list');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  //   // Refresh interval disabled to prevent perceptible page reloads during decoding workflow
  //   // const interval = setInterval(fetchData, 10000);
  //   // return () => clearInterval(interval);
  // }, []);

  // const handleKeyFileSelect = (event: React.ChangeEvent<HTMLInputElement>, dataName: string) => {
  //   const file = event.target.files?.[0];
  //   if (file) {
  //     setSelectedKeyFiles(prev => ({
  //       ...prev,
  //       [dataName]: file
  //     }));
  //   }
  // };

  // const handleDownload = async (dataName: string, fileType: string) => { ... legacy ... };
  // const toggleKeyFileUpload = (dataName: string) => { ... };
  // const handleCancelKeyUpload = (dataName: string) => { ... };
  // const handleDelete = async (dataName: string) => { ... };
  // const formatFileSize = (bytes: number) => { ... };
  // const formatDate = (dateString: string) => { ... };
  // const getFileIcon = (fileType: string | undefined) => { ... };
  // const getFileTypeColor = (fileType: string | undefined) => { ... };

  const handleGlobalKeySelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setGlobalKeyFile(file);
      toast.info('Key file ready. Click "Decode with Key" to retrieve your data.');
    } else {
      setGlobalKeyFile(null);
    }
  };

  const handleGlobalKeyClear = () => {
    setGlobalKeyFile(null);
    if (globalKeyInputRef.current) {
      globalKeyInputRef.current.value = '';
    }
  };

  const handleGlobalDecode = async () => {
    if (!globalKeyFile) {
      toast.error('Please select a key file first');
      return;
    }

    try {
      setGlobalDecoding(true);
      const response = await decodeFileByKey(globalKeyFile);

      const dataNameHeader = response.headers['x-chitram-data-name'];
      const fileName = (() => {
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="([^"]+)"/);
          if (fileNameMatch) {
            return fileNameMatch[1];
          }
        }
        if (dataNameHeader) {
          return dataNameHeader;
        }
        return 'decoded-file';
      })();

      const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success(`Decoded "${fileName}" from ${dataNameHeader || 'unknown data'}`);
      handleGlobalKeyClear();
    } catch (error: any) {
      const message =
        error?.response?.data?.error ||
        error?.message ||
        'Failed to decode file. Please verify your key file and try again.';
      toast.error(message);
    } finally {
      setGlobalDecoding(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Download size={32} className="text-gold" />
          <div>
            <h1 className="text-3xl font-bold text-gold mx-5">Decode Stored DNA Data</h1>
            <p className="text-gray-300 text-sm">
              Upload any DNA key file generated by the system to recover your original file—even after restarts.
            </p>
          </div>
        </div>
        <Link
          to={uploadLink}
          className="btn border-[#31B9C7] text-[#31B9C7] hover:bg-[#31B9C7] hover:text-black flex items-center gap-2 mt-4 mb-4"
        >
          <Upload size={16} />
          Go to Engrave
        </Link>
      </header>

      {/* Global Key Decode */}
      <div className="card border-[#31B9C7] bg-[#0f1f2a] bg-opacity-60 mb-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-start gap-3 w-full">
            <div className="text-[#31B9C7] mt-1">
              <Key size={24} />
            </div>
            <div className="flex-1">
              <h3 className="text-[#31B9C7] font-semibold text-lg">Decode Using Any Key File</h3>
              <p className="text-sm text-gray-300">
                Upload the DNA key file you received during engraving. The system will restore your data even if it&apos;s not listed below.
              </p>
              <div className="mt-4 space-y-2">
                <label className="block text-sm font-medium text-gray-300">
                  Key File (.txt)
                </label>
                {/* Native input hidden to avoid default browser chrome */}
                {/* <input
                  ref={globalKeyInputRef}
                  type="file"
                  accept=".txt"
                  onChange={handleGlobalKeySelect}
                  className="w-full border border-[#31B9C7] bg-black text-gray-200 px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#31B9C7] file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:bg-[#31B9C7] file:text-black"
                /> */}
                <input
                  ref={globalKeyInputRef}
                  type="file"
                  accept=".txt"
                  onChange={handleGlobalKeySelect}
                  className="hidden"
                  style={{ display: 'none' }}
                />
                <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                  <button
                    onClick={() => globalKeyInputRef.current?.click()}
                    className="btn border-[#31B9C7] text-[#31B9C7] hover:bg-[#31B9C7] hover:text-black flex items-center gap-2"
                  >
                    <Upload size={16} />
                    {globalKeyFile ? 'Change Key File' : 'Upload Key File'}
                  </button>
                  <span className="text-sm text-gray-300">
                    {globalKeyFile ? `Selected: ${globalKeyFile.name}` : 'No key file selected yet.'}
                  </span>
                </div>
                <p className="text-xs text-gray-400">
                  Select the DNA key file (around 10 KB) that was generated after engraving. The file contains encoded ATGC sequences.
                </p>
                {/* {globalKeyFile && (
                  <div className="mt-3 bg-[#12333a] border border-[#31B9C7] rounded-lg p-3 text-sm text-[#31B9C7]">
                    Key ready: {globalKeyFile.name}
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <button
              onClick={handleGlobalDecode}
              disabled={!globalKeyFile || globalDecoding}
              className={`btn flex items-center gap-2 ${
                !globalKeyFile
                  ? 'border-gray-500 text-gray-500 cursor-not-allowed'
                  : globalDecoding
                  ? 'btn-primary opacity-75 cursor-wait'
                  : 'btn-primary'
              }`}
            >
              {globalDecoding ? (
                <>
                  <RefreshCw size={16} className="animate-spin" />
                  Decoding...
                </>
              ) : (
                <>
                  <Download size={16} />
                  Decode with Key
                </>
              )}
            </button>
            {globalKeyFile && !globalDecoding && (
              <button
                onClick={handleGlobalKeyClear}
                className="btn border-gray-600 text-gray-300 hover:bg-gray-700 flex items-center gap-2"
              >
                <Upload size={16} />
                Clear
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="card border-blue-500 bg-blue-900 bg-opacity-10">
        <div className="flex items-start gap-3">
          <div className="text-blue-400 mt-1">
            <File size={20} />
          </div>
          <div className="space-y-2">
            <h3 className="text-blue-400 font-semibold">How decoding works</h3>
            <ol className="list-decimal list-inside text-sm text-blue-100 space-y-1">
              <li>Select the DNA key file you downloaded after engraving (looks like a long ATGC sequence).</li>
              <li>Click <span className="text-[#31B9C7] font-semibold">Decode with Key</span>. The system rehydrates the encrypted metadata and restores your file.</li>
              <li>You can reuse the same key again anytime.</li>
            </ol>
          </div>
        </div>
      </div>

      <div className="card text-center py-10">
        <h3 className="text-xl font-bold text-gray-300 mb-2">Need to engrave something new?</h3>
        <p className="text-gray-400 mb-4">
          Head back to the engraving area to create fresh DNA sequences and key files.
        </p>
        <Link to={uploadLink} className="btn btn-primary flex items-center gap-2 justify-center mx-auto w-fit">
          <Upload size={16} />
          Start Engraving
        </Link>
      </div>
    </div>
  );
};

export default DownloadPage;
